import { Component, OnInit } from '@angular/core';
import { AppConfig } from '@config/app.config';

@Component({
  selector: 'app-no-elements-filter-view',
  templateUrl: './no-elements-filter-view.component.html'
})
export class NoElementsFilterViewComponent implements OnInit {
  constructor(public appConfig: AppConfig) {}

  ngOnInit() {}
}
